export const studentMode = (mode) => {
  
  // Handle successful mode navigation
  switch (mode ) {
    case "RESEND_MAIL":
      return "/student/otp";
    case "LOGIN-OTP":
      return "/student/login-otp";
    case "VERIFY_SIGNUP":
      return "/student/otp";
    case "PERSONALINFO":
      return "/student/personal-info";
    case "PERSONALDOC":
      return "/student/personal-doc" ;
    case "LETS_CONTINUE":
      return "/student/lets-continue";
    case "PORTFOLIO":
      return "/student/skills";
    case "EDIT_EDUCATION_DETAILS":
      return "/student/academic-info";
    case "EDIT_PORTFOLIO":
      return "/student/edit/skills";      
    default:
      return "/page-not-found";
  }
};

